import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import {
  ExtendedFlex,
  formatters,
} from '../../coreui';

import tooltipData from '../headerData';
import Header from '../../ioDetails/components/header';
import HeaderHighlight from '../../ioDetails/components/headerHighlight';

// load a locale
numeral.register('locale', 'rm', {
  delimiters: {
    thousands: ',',
    decimal: '.',
  },
  abbreviations: {
    thousand: 'k',
    million: 'mm',
    billion: 'b',
    trillion: 't',
  },
  currency: {
    symbol: '$',
  },
});
// switch between locales
numeral.locale('rm');

// eslint-disable-next-line
class ReitHeader extends React.Component {
  render() {
    const {
      title,
      subTitle,
      highlights,
      id,
    } = this.props;

    let tt = {};

    switch (id) {
      case 274949:
        tt = tooltipData.mr2;
        break;
      default:
        tt = tooltipData.mr1;
        break;
    }

    const highlightsComponent = (
      <ExtendedFlex
        flexDirection="row"
      >
        <HeaderHighlight
          id="assetValue"
          tooltip={tt.value}
          label="Total Asset Value"
          highlight={numeral(highlights.investedValue).format('$0a')}
        />
        <HeaderHighlight
          id="numInvestments"
          tooltip={tt.investments}
          label="Number of Investments"
          highlight={highlights.numInvestments}
        />
        <HeaderHighlight
          id="numInvestors"
          tooltip={tt.investors}
          label="Number of Investors"
          highlight={numeral(highlights.numInvestors).format(formatters.INTEGER)}
          mr={[5, 10, 10, 40, 0]}
        />
      </ExtendedFlex>
    );

    return (
      <Header
        title={title}
        subTitle={subTitle}
        highlights={highlightsComponent}
      />
    );
  }
}

ReitHeader.propTypes = {
  title: PropTypes.any,
  subTitle: PropTypes.string,
  highlights: PropTypes.object,
  id: PropTypes.number,
};

export default ReitHeader;
